export default "data:video/mp2t;base64,ZXhwb3J0IGNvbnN0IFRBQkxFX1JPV19IRUlHSFQgPSAzNgpleHBvcnQgY29uc3QgUEFHSU5BVElPTl9IRUlHSFQgPSA1Mwo="